import { APICore } from './apiCore'

const api = new APICore()

function getConfOpinometro (owner, destination) {
  let baseUrl = `/conf-opinometro/${owner}`
  if (destination) {
    baseUrl += `/${destination}`
  }
  return api.get(baseUrl, {})
}

function updateConfOpinometro (params) {
  const baseUrl = '/conf-opinometro'
  return api.updateWithFile(baseUrl, params)
}

export { getConfOpinometro, updateConfOpinometro }
